function lucceDiamondGradingSummary(params, suffix) {
  const isRound = /^round(?:\s+cut)?$/i.test(String(shape || '').trim());
  return [['cut_precision', 'Cut'], ['polish', 'Polish'], ['symmetry', 'Symmetry']].filter(function (field) {
    return field[0] !== 'cut_precision' || isRound;
  }).map(function (field) {
    const value = (params.get(field[0] + suffix) || '').trim();
    return value && value !== 'null' && value !== 'undefined' && value !== 'U' ? ', ' + value : '';
  }).join('');
}

function lucceFluorescenceSummary(code) {
  const labels = { N: 'None', F: 'Faint', VSL: 'Very Slight', M: 'Medium', SL: 'Slight', NONE: 'None', FAINT: 'Faint', 'VERY SLIGHT': 'Very Slight', MEDIUM: 'Medium', SLIGHT: 'Slight' };
  const value = labels[String(code || '').trim().toUpperCase()];
  return value ? ', ' + value : '';
}

let web_server = 'https://api.luccerings.com'
let shapes = ['ROUND', 'OVAL','EMERALD','PEAR','CUSHION','ROSE','ASSCHER','RADIANT','MARQUISE','PRINCESS','ANTIQUE','HEART','TRILLIANT']
let price1
let price2

let product_form = document.getElementById('Customize-Product-Form')
let selection_wrapper = document.getElementById('Customize-Selection-Wrapper')


let make_selection_btn_1 = document.getElementById('Customize-Make-Selection')
let make_selection_btn_2 = document.getElementById('Customize-Make-Selection2')
let ring_name = document.getElementById('Customize-Product-Title').innerText
let ring_handle = document.getElementById('Customize-Product-Handle').innerText
let shape = getShape()
let ring_shape = capitalizeFirstLetter(shape.toLowerCase()) + ' Cut'
let ring_size = getRingSize()
//let ring_img = Array.from(document.querySelector('div[data-thumbnail-slider]').querySelectorAll('img'))[0].src
let metal_variant_elems = Array.from(document.getElementById('Customize-Metal-Select').querySelectorAll('option'))
let metal_variants = []
let diamond_type = 0






metal_variant_elems.forEach(option=>{
    let name = option.innerText.trim()
    metal_variants.push({'id': option.value,'name':name})
})

//let base_url = 'http://127.0.0.1:9292'
//let base_url = 'https://lucce-development-store.myshopify.com'
let base_url = 'https://luccerings.com'

function formatLuccePhpText(price){
    let phpPrice = Number(price)
    if(window.LucceCurrencyFormatter && typeof window.LucceCurrencyFormatter.formatPhpPrice === 'function'){
        return window.LucceCurrencyFormatter.formatPhpPrice(phpPrice)
    }
    return '₱' + phpPrice.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })
}

function formatLuccePhpHtml(price){
    let phpPrice = Number(price)
    let displayPrice = formatLuccePhpText(phpPrice)
    return '<span data-lucce-convert data-lucce-php-price="' + phpPrice + '">' + displayPrice + '</span>'
}

function refreshLucceCurrency(){
    if(window.LucceCurrencyFormatter && typeof window.LucceCurrencyFormatter.refresh === 'function'){
        window.LucceCurrencyFormatter.refresh()
    }
}

function lucceEscapeAttribute(value){
    return String(value || '').replace(/[&<>"']/g, function(char){
        return {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;'
        }[char]
    })
}

async function addEarringBundleToCart(diamondId, diamondId2, settingId){
    const boxEngravingText = document.getElementById('Customize-Diamond-Box-Engravings')?.value.trim()
    const settingItem = {
        id: Number(settingId),
        quantity: 1
    }

    if(boxEngravingText){
        settingItem.properties = {
            'Box Engraving': lucceEscapeAttribute(boxEngravingText)
        }
    }

    await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify({
            items: [
                { id: Number(diamondId), quantity: 1 },
                { id: Number(diamondId2), quantity: 1 },
                settingItem
            ]
        })
    })

    location.href = '/cart?storefront=true'
}

let v_setting_id = document.getElementById('Customize-Metal-Select').value

//diamond selected 1
let selected_info_top = document.getElementById('Customize-Selected-Diamond-Info-Item-Top')
let selected_info_mid = document.getElementById('Customize-Selected-Diamond-Info-Item-Mid')
let selected_info_bot = document.getElementById('Customize-Selected-Diamond-Info-Item-Bot')
let selected_info_img = document.getElementById('Customize-Selected-Diamond-Info-Item-Img')
let selected_info_change = document.getElementById('Customize-Selected-Diamond-Info-Item-Change')

//diamond selected
let selected_info_top2 = document.getElementById('Customize-Selected-Diamond2-Info-Item-Top')
let selected_info_mid2 = document.getElementById('Customize-Selected-Diamond2-Info-Item-Mid')
let selected_info_bot2 = document.getElementById('Customize-Selected-Diamond2-Info-Item-Bot')
let selected_info_img2 = document.getElementById('Customize-Selected-Diamond2-Info-Item-Img')
let selected_info_change2 = document.getElementById('Customize-Selected-Diamond2-Info-Item-Change')



let url = new URL(location.href)
let metal_param = url.searchParams.get('metal')

let modify = url.searchParams.get('modify')
let diamond1_selected = url.searchParams.get('diamond1_selected')
let d1 = url.searchParams.get('d1')
let d2 = url.searchParams.get('d2')

if(url.searchParams.get('diamond_type')){
    diamond_type = url.searchParams.get('diamond_type')
    if (diamond_type == '0'){
        document.getElementById('Customize-Center-Diamond-Option-Natural').style.opacity = '.4'
        document.getElementById('Customize-Center-Diamond-Option-Natural').style.cursor = 'auto'
         document.getElementById('Customize-Center-Diamond-Option-Lab').style.cursor = 'auto'
    } else {
        document.getElementById('Customize-Center-Diamond-Option-Lab').style.opacity = '.4'
        document.getElementById('Customize-Center-Diamond-Option-Natural').style.cursor = 'auto'
         document.getElementById('Customize-Center-Diamond-Option-Lab').style.cursor = 'auto'
    }
}

if(d1 == 'Y' && d2 == 'Y'){

    let d1_details = getDiamond1Details()
    let d2_details = getDiamond2Details()
    price1 = d1_details['price']
    price2 = d2_details['price']

    diamond_type = url.searchParams.get('diamond_type')

    let diamond_type_lbl = 'Lab Grown'

    if(diamond_type == '1'){
        diamond_type_lbl = 'Natural'
    }

    // price = url.searchParams.get('price')
    // let cts = url.searchParams.get('cts')
    // let color = url.searchParams.get('color')
    // let clarity = url.searchParams.get('clarity')
    // let lab = url.searchParams.get('lab')
    // let lab_n = url.searchParams.get('lab_numb')
    // let img = url.searchParams.get('img')
    // let id = url.searchParams.get('id')
    // let diamond_id = url.searchParams.get('diamond_id')


    
    //set options - ring metal, ring size, engraving
    let prev_selected_metal = url.searchParams.get('metal')
    let prev_selected_size = url.searchParams.get('size')

    setMetal(prev_selected_metal)
    setRingSize(prev_selected_size)
    setTimeout(()=>{
        setOldMetalSelect()
    },500)
    

    //set diamond 1
    selected_info_img.src = d1_details['img']
    selected_info_top.innerText = shape + ' ' + d1_details['cts'] + 'ct ' + diamond_type_lbl + ' Diamond, ' + d1_details['color'] +', ' + d1_details['clarity'] + lucceDiamondGradingSummary(url.searchParams, '') + lucceFluorescenceSummary(url.searchParams.get('fluorescent'))
    selected_info_mid.innerText = d1_details['lab'] + ' Certificate: ' + d1_details['lab_n']
    selected_info_bot.innerHTML = formatLuccePhpHtml(d1_details['price'])

    //set diamond 2
    selected_info_img2.src = d2_details['img']
    selected_info_top2.innerText =  shape + ' ' + d2_details['cts'] + 'ct ' + diamond_type_lbl + ' Diamond, ' + d2_details['color'] +', ' + d2_details['clarity'] + lucceDiamondGradingSummary(url.searchParams, '2') + lucceFluorescenceSummary(url.searchParams.get('fluorescent2'))
    selected_info_mid2.innerText = d2_details['lab'] + ' Certificate: ' + d2_details['lab_n']
    selected_info_bot2.innerHTML = formatLuccePhpHtml(d2_details['price'])
    refreshLucceCurrency()

    make_selection_btn_1.style.display = 'none'
    updateTotalPrice(d1_details['price'],d2_details['price'])
    //scrollToTitle()
    document.getElementById('Customize-Selected-Diamond-Container').style.display = 'flex'
    document.getElementById('Customize-Diamond-Label').style.display = 'block'
    document.getElementById('Customize-Selected-Diamond2-Container').style.display = 'flex'
    document.getElementById('Customize-Diamond2-Label').style.display = 'block'

    //change diamond btn
    selected_info_change.addEventListener('click',()=>{
        let ring_img = getRingImg()
        let metal = getMetal()
        let ring_size = getRingSize()
        let d_link2 = getDiamond2Link(metal,ring_size)
        location.href = '/pages/diamond-selection?name=' + ring_name +'&shape=' + ring_shape +
                            '&size=' + ring_size + '&metal=' + metal + '&ring_img=' + ring_img + '&handle=' + ring_handle + '&engravings=' + d_link2 + '&natural=' + diamond_type
    })

    selected_info_change2.addEventListener('click',()=>{
        let ring_img = getRingImg()
        let metal = getMetal()
        let ring_size = getRingSize()
        let d_link1 = getDiamond1Link(metal,ring_size)
        location.href = '/pages/diamond-selection?name=' + ring_name +'&shape=' + ring_shape +
                            '&size=' + ring_size + '&metal=' + metal + '&ring_img=' + ring_img + '&handle=' + ring_handle + '&engravings=' + d_link1 + '&natural=' + diamond_type
    })


    
    make_selection_btn_2.classList.add('customize-total-cart-btn')
    const boxEngravingWrapper = document.getElementById('Customize-Box-Engravings-Wrapper');
    const finalSelectionWrapper = document.getElementById('Customize-Selection-Wrapper2');
    if (boxEngravingWrapper && finalSelectionWrapper) boxEngravingWrapper.after(finalSelectionWrapper);
    
    //Add items to cart
    make_selection_btn_2.addEventListener('click',async ()=>{
        //let pass_check = checkRingSize()
        let pass_check = true
        if(pass_check){

            let height = make_selection_btn_2.getBoundingClientRect().height
            let btn_original_text = make_selection_btn_2.innerHTML
            //Set loader
            make_selection_btn_2.innerHTML =`<div style="visibility:visible;">
            <div class="buy-customize-loader" title="1">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="#fff" xmlns="http://www.w3.org/2000/svg"><style>.spinner_6kVp{transform-origin:center;animation:spinner_irSm .75s infinite linear}@keyframes spinner_irSm{100%{transform:rotate(360deg)}}</style><path d="M10.72,19.9a8,8,0,0,1-6.5-9.79A7.77,7.77,0,0,1,10.4,4.16a8,8,0,0,1,9.49,6.52A1.54,1.54,0,0,0,21.38,12h.13a1.37,1.37,0,0,0,1.38-1.54,11,11,0,1,0-12.7,12.39A1.54,1.54,0,0,0,12,21.34h0A1.47,1.47,0,0,0,10.72,19.9Z" class="spinner_6kVp"/></svg>
            </div>
            </div>`
            make_selection_btn_2.style.textAlign = 'center'
            make_selection_btn_2.style.color = '#fff'
            make_selection_btn_2.style.height = height + 'px'

            //send diamond id, lab number to lucce api
            let data = {
                id:d1_details['id'],
                id2:d2_details['id'],
                earrings: 'Y',
                engravings: 'N',
                engravings_msg: '',
                code:'1c3f96c0981de4b7f2fd4f505bd4d1493b4660c07203f786b5f133ddc9fa53eb0f6c551b',
            }
        
            fetch(web_server +'/create_diamond',
                    {method: 'POST',body: JSON.stringify(data)}
                    )
            .then(resp=>resp.json())
            .then(data=>{
                
                v_setting_id = document.getElementById('Customize-Metal-Select').value
                v_setting_size = document.getElementById('Customize-Size-Select').options[document.getElementById('Customize-Size-Select').selectedIndex].text
             
                addEarringBundleToCart(data['diamond_id'], data['diamond_id2'], v_setting_id)
            
            
            })
            .catch(err=>{
                console.log(err)
                make_selection_btn_2.innerHTML = 'Error'
        
                setTimeout(()=>{
                make_selection_btn_2.innerHTML = btn_original_text
                },1000)
            })


 
        }
        
    })


    
}
// else if(modify == 'Y'){
//         //set options - ring metal, ring size, engraving
//     let prev_selected_metal = url.searchParams.get('metal')
//     let prev_selected_size = url.searchParams.get('size')

//     setMetal(prev_selected_metal)
//     setRingSize(prev_selected_size)
//     setTimeout(()=>{
//         setOldMetalSelect()
//     },500)
    

//     setSelectionLink()
//     //scrollToTitle()
// } 
else if(d1 == 'Y' && d2 == 'N'){
    let prev_selected_metal = url.searchParams.get('metal')
    let prev_selected_size = url.searchParams.get('size')

    setMetal(prev_selected_metal)
    setRingSize(prev_selected_size)
    setTimeout(()=>{
        setOldMetalSelect()
    },500)
    let d1_details = getDiamond1Details()
    diamond_type = url.searchParams.get('diamond_type')

    let diamond_type_lbl = 'Lab Grown'

    if(diamond_type == '1'){
        diamond_type_lbl = 'Natural'
    }
    //set diamond 1
    selected_info_img.src = d1_details['img']
    selected_info_top.innerText =  shape + ' ' + d1_details['cts'] + 'ct ' + diamond_type_lbl + ' Diamond, ' + d1_details['color'] +', ' + d1_details['clarity'] + lucceDiamondGradingSummary(url.searchParams, '') + lucceFluorescenceSummary(url.searchParams.get('fluorescent'))
    selected_info_mid.innerText = d1_details['lab'] + ' Certificate: ' + d1_details['lab_n']
    selected_info_bot.innerHTML = formatLuccePhpHtml(d1_details['price'])
    refreshLucceCurrency()
    setSelectionLink(d1_details,{'chosen':'N'})

    make_selection_btn_1.style.display = 'none'
    document.getElementById('Customize-Selected-Diamond-Container').style.display = 'flex'
    document.getElementById('Customize-Diamond-Label').style.display = 'block'

    selected_info_change.addEventListener('click',()=>{
        let ring_img = getRingImg()
        let metal = getMetal()
        let ring_size = getRingSize()
        location.href = '/pages/diamond-selection?name=' + ring_name +'&shape=' + ring_shape +
        '&size=' + ring_size + '&metal=' + metal + '&ring_img=' + ring_img + '&handle=' + ring_handle + '&engravings=' + '&natural=' + diamond_type
        + '&earrings=true&d1=N&d2=N'
    })

}
else if(d1 == 'N' && d2 == 'Y'){
    let prev_selected_metal = url.searchParams.get('metal')
    let prev_selected_size = url.searchParams.get('size')

    setMetal(prev_selected_metal)
    setRingSize(prev_selected_size)
    setTimeout(()=>{
        setOldMetalSelect()
    },500)

    let d2_details = getDiamond2Details()
    diamond_type = url.searchParams.get('diamond_type')

    let diamond_type_lbl = 'Lab Grown'

    if(diamond_type == '1'){
        diamond_type_lbl = 'Natural'
    }
    //set diamond 2
    selected_info_img2.src = d2_details['img']
    selected_info_top2.innerText =  shape + ' ' + d2_details['cts'] + 'ct ' + diamond_type_lbl + 'Diamond, ' + d2_details['color'] +', ' + d2_details['clarity'] + lucceDiamondGradingSummary(url.searchParams, '2') + lucceFluorescenceSummary(url.searchParams.get('fluorescent2'))
    selected_info_mid2.innerText = d2_details['lab'] + ' Certificate: ' + d2_details['lab_n']
    selected_info_bot2.innerHTML = formatLuccePhpHtml(d2_details['price'])
    refreshLucceCurrency()
    setSelectionLink({'chosen':'N'},d2_details)

    make_selection_btn_2.style.display = 'none' 
    document.getElementById('Customize-Selected-Diamond2-Container').style.display = 'flex'
    document.getElementById('Customize-Diamond2-Label').style.display = 'block'

    selected_info_change2.addEventListener('click',()=>{
        let ring_img = getRingImg()
        let metal = getMetal()
        let ring_size = getRingSize()
        location.href = '/pages/diamond-selection?name=' + ring_name +'&shape=' + ring_shape +
        '&size=' + ring_size + '&metal=' + metal + '&ring_img=' + ring_img + '&handle=' + ring_handle + '&engravings=' 
        + '&earrings=true&d1=N&d2=N&d2click=true' + '&natural=' + diamond_type
    })
}
else{
    //no diamonds chosen yet
    setSelectionLink({'chosen':'N'},{'chosen':'N'})
}










function setSelectionLink(diamond1_dict,diamond2_dict){

    let d1_details
    if(diamond1_dict['chosen'] == 'Y'){
        d1_details = '&cts=' + diamond1_dict['cts'] +
        '&color=' + diamond1_dict['color'] + '&clarity=' + diamond1_dict['clarity'] +
        '&lab=' + diamond1_dict['lab'] + '&lab_numb=' + diamond1_dict['lab_n'] + 
        '&img='+ diamond1_dict['img'] + '&price=' + diamond1_dict['price'] + 
        '&id=' + diamond1_dict['id']
    } else {
        d1_details = ''
    }

    let d2_details
    if(diamond2_dict['chosen'] == 'Y'){
        d2_details = '&cts=' + diamond2_dict['cts'] +
        '&color=' + diamond2_dict['color'] + '&clarity=' + diamond2_dict['clarity'] +
        '&lab=' + diamond2_dict['lab'] + '&lab_numb=' + diamond2_dict['lab_n'] + 
        '&img='+ diamond2_dict['img'] + '&price=' + diamond2_dict['price'] + 
        '&id=' + diamond2_dict['id']
    } else {
        d2_details = ''
    }





    if(make_selection_btn_1 && diamond1_dict['chosen'] !== 'Y'){    
        make_selection_btn_1.addEventListener('click',()=>{
            let ring_img = getRingImg()
            let height = make_selection_btn_1.getBoundingClientRect().height
            make_selection_btn_1.innerHTML =`<div style="visibility:visible;">
                <div class="buy-customize-loader" title="1">
                    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><style>.spinner_6kVp{transform-origin:center;animation:spinner_irSm .75s infinite linear}@keyframes spinner_irSm{100%{transform:rotate(360deg)}}</style><path d="M10.72,19.9a8,8,0,0,1-6.5-9.79A7.77,7.77,0,0,1,10.4,4.16a8,8,0,0,1,9.49,6.52A1.54,1.54,0,0,0,21.38,12h.13a1.37,1.37,0,0,0,1.38-1.54,11,11,0,1,0-12.7,12.39A1.54,1.54,0,0,0,12,21.34h0A1.47,1.47,0,0,0,10.72,19.9Z" class="spinner_6kVp"/></svg>
                </div>
            </div>`
        make_selection_btn_1.style.textAlign = 'center'
        make_selection_btn_1.style.height = height + 'px'
            let metal = getMetal()
            let ring_size = getRingSize()
            setTimeout(()=>{
                location.href = '/pages/diamond-selection?name=' + ring_name +'&shape=' + ring_shape +
                '&size=' + ring_size + '&metal=' + metal + '&ring_img=' + ring_img + '&handle=' + ring_handle + '&engravings=' 
                + '&earrings=true&d1=' + diamond1_dict['chosen'] + '&d2=' + diamond2_dict['chosen'] + d2_details + '&natural=' + diamond_type
            },500)

        })
    }

    if(make_selection_btn_2 && diamond2_dict['chosen'] !== 'Y'){
      
        make_selection_btn_2.addEventListener('click',()=>{
            let ring_img = getRingImg()
            let height = make_selection_btn_2.getBoundingClientRect().height
            make_selection_btn_2.innerHTML =`<div style="visibility:visible;">
                <div class="buy-customize-loader" title="1">
                    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><style>.spinner_6kVp{transform-origin:center;animation:spinner_irSm .75s infinite linear}@keyframes spinner_irSm{100%{transform:rotate(360deg)}}</style><path d="M10.72,19.9a8,8,0,0,1-6.5-9.79A7.77,7.77,0,0,1,10.4,4.16a8,8,0,0,1,9.49,6.52A1.54,1.54,0,0,0,21.38,12h.13a1.37,1.37,0,0,0,1.38-1.54,11,11,0,1,0-12.7,12.39A1.54,1.54,0,0,0,12,21.34h0A1.47,1.47,0,0,0,10.72,19.9Z" class="spinner_6kVp"/></svg>
                </div>
            </div>`
        make_selection_btn_2.style.textAlign = 'center'
        make_selection_btn_2.style.height = height + 'px'
            let metal = getMetal()
            let ring_size = getRingSize()
            setTimeout(()=>{
                location.href = '/pages/diamond-selection?name=' + ring_name +'&shape=' + ring_shape +
                '&size=' + ring_size + '&metal=' + metal + '&ring_img=' + ring_img + '&handle=' + ring_handle + '&engravings=' + 
                '&earrings=true&d1=' + diamond1_dict['chosen'] + '&d2=' + diamond2_dict['chosen'] + d1_details + '&d2click=true' + '&natural=' + diamond_type
            },500)

        })
    }
}


function updateTotalPrice(diamond1,diamond2){
    let select = document.getElementById('Customize-Metal-Select')
    let price = Number(select.options[select.selectedIndex].dataset.price)/100
    //let ring_setting_price_normal = Number(document.getElementById('Customize-Product-Price').innerText)/100
    let total = formatLuccePhpText(Number(diamond1) + Number(diamond2) + Number(price))
    let totalWrapper = document.getElementById('Customize-Total-Price-Wrapper')
    let totalText = document.getElementById('Customize-Total-Price-Text')
    if (totalWrapper && totalText) {
        totalText.textContent = total
        totalWrapper.style.display = 'block'
    }
    let buttonText = totalWrapper ? totalWrapper.dataset.buildLabel : "BUILD YOUR FOREVER PIECE"
    if(make_selection_btn_2.innerText !== buttonText){
        make_selection_btn_2.innerText = buttonText
    }
}

document.addEventListener('lucce:currency:updated', function(){
    if(price1 && price2){
        updateTotalPrice(price1, price2)
    }
})

function getMetal(){
    let metal
    let setting_id = document.getElementById('Customize-Metal-Select').value
    
    metal_variants.forEach(variant=>{
        if(variant['id'] == setting_id){
            metal = variant['name']
        }
    })

    

    return metal
}

function setMetal(metal_name){
    Array.from(document.getElementById('Customize-Metal-Select').querySelectorAll('option')).forEach(option=>{
        if(option.innerText.toLocaleLowerCase().trim() === metal_name.toLocaleLowerCase().trim()){
            option.selected = true
        }
    })

}


function getRingSize(){
    let val = Number(document.getElementById('Customize-Size-Select').value)
    
    if(val !== 0 && val !== 1){
        return val
    } 

    return null
}


function setRingSize(ring_size){
    Array.from(document.getElementById('Customize-Size-Select').querySelectorAll('option')).forEach(option=>{
        if(option.innerText.toLocaleLowerCase().trim() === ring_size.toLocaleLowerCase().trim()){
            option.selected = true
        }
    })

}

// function checkRingSize(){
//     let val = Number(document.getElementById('Customize-Size-Select').value)

//     if(val !== 0){
//         return true
//     } 

//     document.getElementById('Customize-Product-Error-Text').innerText = "Please select ring size"

//     return false
// }

let customize_size_select = document.getElementById('Customize-Size-Select')
customize_size_select .addEventListener('change',()=>{
    if(customize_size_select.value !== '0'){
        document.getElementById('Customize-Product-Error-Text').innerText = ""
    }
})


function scrollToTitle(){
    if(window.innerWidth < 750){
        let title = document.querySelector('.product-single__title')
        if(title){
            // let y = title.getBoundingClientRect().top
            // window.scrollTo(0,y)
            title.scrollIntoView()
        }
    }
}

function getShape(){
    let tags = document.getElementById('Customize-Product-Tags').querySelectorAll('li')
    let shape_found = ''
    tags.forEach(tag=>{
        let tag_txt_uppercase = tag.innerText.toUpperCase()
        shapes.forEach(shape=>{
            if(tag_txt_uppercase.includes(shape)){
                shape_found = shape
            }
        })
    })

    if (shape_found == '')
    shape_found = 'ROUND'

    return shape_found
}

function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }



document.getElementById('Customize-Metal-Select').addEventListener('change',(e)=>{
    setOldMetalSelect()
})

function setOldMetalSelect(){
    let old_metal_select = document.querySelector('.single-option-selector-product-template-lab-diamond-earrings')
    let old_metal_select_options = Array.from(old_metal_select.querySelectorAll('option'))
    let select = document.getElementById('Customize-Metal-Select')
    let selected = select.options[select.selectedIndex].text

    old_metal_select_options.forEach(option=>{
        if(option.innerText.toLowerCase().trim() == selected.toLowerCase().trim()){
           old_metal_select.selectedIndex = option.index
           
           let event = new Event('change')
           old_metal_select.dispatchEvent(event)
           
           if(d1 == 'Y' && d2 == 'Y'){
            updateTotalPrice(price1,price2)
           }
        }
    })
}

function getRingImg(){
    let objs = Array.from(document.querySelectorAll('.product-single__media-wrapper'))
    let img = ''
    objs.forEach(o=>{
        if(o.classList.contains('hide') == false){
            img = getBestRingImageUrl(o.querySelector('img'))
        }
    })

    if(img == '')
    img = Array.from(document.querySelector('div[data-thumbnail-slider]').querySelectorAll('img'))[0].src

    return img
}

function getBestRingImageUrl(image){
    if(!image) return ''

    if(image.srcset){
        let candidates = image.srcset.split(',').map(candidate=>{
            let parts = candidate.trim().split(/\s+/)
            return {
                url: parts[0],
                width: Number((parts[1] || '').replace('w', '')) || 0
            }
        }).filter(candidate=>candidate.url)

        let preferred = candidates.find(candidate=>candidate.width >= 360)
        if(preferred) return preferred.url

        if(candidates.length > 0) return candidates[candidates.length - 1].url
    }

    return image.currentSrc || image.src || ''
}


function getDiamond1Details(){
    price = url.searchParams.get('price')
    let cts = url.searchParams.get('cts')
    let color = url.searchParams.get('color')
    let clarity = url.searchParams.get('clarity')
    let lab = url.searchParams.get('lab')
    let lab_n = url.searchParams.get('lab_numb')
    let img = url.searchParams.get('img')
    let id = url.searchParams.get('id')

    let dict = {
        'chosen':'Y',
        'cts':cts,
        'color':color,
        'clarity': clarity,
        'lab':lab,
        'lab_n': lab_n,
        'img': img,
        'id':id,
        'price':price
    }

    return dict
}

function getDiamond1Link(metal,size){
    price = url.searchParams.get('price')
  let cts = url.searchParams.get('cts')
  let color = url.searchParams.get('color')
  let clarity = url.searchParams.get('clarity')
  let lab = url.searchParams.get('lab')
  let lab_n = url.searchParams.get('lab_numb')
  let img = url.searchParams.get('img')
  let id = url.searchParams.get('id')

  let params = '&earrings=true&d1=Y&d2=N&d2click=true&cts=' + cts +
  '&color=' + color + '&clarity=' + clarity +
  '&metal=' + metal + '&size=' + size +
  '&lab=' + lab + '&lab_numb=' + lab_n + 
  '&img='+ img + '&price=' + price + 
  '&id=' + id

  params += '&fluorescent=' + encodeURIComponent(url.searchParams.get('fluorescent') || '')
  params += '&cut_precision=' + encodeURIComponent(url.searchParams.get('cut_precision') || '')
  params += '&polish=' + encodeURIComponent(url.searchParams.get('polish') || '')
  params += '&symmetry=' + encodeURIComponent(url.searchParams.get('symmetry') || '')
  return params
}

function getDiamond2Details(){
    price = url.searchParams.get('price2')
    let cts = url.searchParams.get('cts2')
    let color = url.searchParams.get('color2')
    let clarity = url.searchParams.get('clarity2')
    let lab = url.searchParams.get('lab2')
    let lab_n = url.searchParams.get('lab_numb2')
    let img = url.searchParams.get('img2')
    let id = url.searchParams.get('id2')

    let dict = {
        'chosen':'Y',
        'cts':cts,
        'color':color,
        'clarity': clarity,
        'lab':lab,
        'lab_n': lab_n,
        'img': img,
        'id':id,
        'price':price
    }

    return dict
}

function getDiamond2Link(metal,size){
    price = url.searchParams.get('price2')
    let cts = url.searchParams.get('cts2')
    let color = url.searchParams.get('color2')
    let clarity = url.searchParams.get('clarity2')
    let lab = url.searchParams.get('lab2')
    let lab_n = url.searchParams.get('lab_numb2')
    let img = url.searchParams.get('img2')
    let id = url.searchParams.get('id2')
  
    let params = '&earrings=true&d1=N&d2=Y&cts=' + cts +
    '&color=' + color + '&clarity=' + clarity +
    '&metal=' + metal + '&size=' + size +
    '&lab=' + lab + '&lab_numb=' + lab_n + 
    '&img='+ img + '&price=' + price + 
    '&id=' + id
  
    params += '&fluorescent2=' + encodeURIComponent(url.searchParams.get('fluorescent2') || '')
    params += '&cut_precision2=' + encodeURIComponent(url.searchParams.get('cut_precision2') || '')
    params += '&polish2=' + encodeURIComponent(url.searchParams.get('polish2') || '')
    params += '&symmetry2=' + encodeURIComponent(url.searchParams.get('symmetry2') || '')
  return params
}


async function get_previous_items(){
    return $.ajax({
        type:'GET',
        url:'\\cart.js',
       });

}

function parse_previous_items(data){
    data = JSON.parse(data)
    //already in cart
    let existing_products = ''
    let items = data['items']

    
    items.forEach(item=>{
        existing_products = existing_products + ',' + item['variant_id'] + ':' + item['quantity']
    })

    return existing_products
}


//center diamond type
let center_diamond_type = document.getElementById('Customize-Center-Diamond-Type')
let center_diamond_option_lab = document.getElementById('Customize-Center-Diamond-Option-Lab')
let center_diamond_option_natural = document.getElementById('Customize-Center-Diamond-Option-Natural')

center_diamond_option_lab.addEventListener('click',(e)=>{
    if(!url.searchParams.get('diamond_type')){
    center_diamond_type.innerText = 'Lab'
    center_diamond_option_natural.classList.remove('customize-center-diamond-option-natural-active')
    center_diamond_option_lab.classList.add('customize-center-diamond-option-lab-active')
    diamond_type = 0
    }
})

center_diamond_option_natural.addEventListener('click',(e)=>{
    if(!url.searchParams.get('diamond_type')){
    center_diamond_type.innerText = 'Natural'
    center_diamond_option_lab.classList.remove('customize-center-diamond-option-lab-active')
    center_diamond_option_natural.classList.add('customize-center-diamond-option-natural-active')
    diamond_type = 1
    }
})

if(diamond_type == 0){
    center_diamond_type.innerText = 'Lab'
    center_diamond_option_natural.classList.remove('customize-center-diamond-option-natural-active')
    center_diamond_option_lab.classList.add('customize-center-diamond-option-lab-active')
} else {
    center_diamond_type.innerText = 'Natural'
    center_diamond_option_lab.classList.remove('customize-center-diamond-option-lab-active')
    center_diamond_option_natural.classList.add('customize-center-diamond-option-natural-active')
}

// add setting price icon
let customize_product_price_ele = document.querySelector('.product__price')
let customize_setting_price_info_icon = document.createElement('span')

customize_setting_price_info_icon.classList.add('customize-setting-price-info-icon-product-page')

customize_setting_price_info_icon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16">
<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
<path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
</svg>`

let customize_setting_price_info_text = document.createElement('div')
customize_setting_price_info_text.style.display = 'none'
customize_setting_price_info_text.classList.add('customize-setting-price-info-text-product-page')

customize_setting_price_info_text.style.maxWidth = document.getElementById('Customize-Make-Selection').getBoundingClientRect().width + 'px'

customize_setting_price_info_text.innerHTML = `<div>The Setting Price refers to the price of the ring’s metalwork that holds your Center Stone. It includes the ring’s accents, pavé, halo, and side stones. It does not include the price of the Center Stone that you will choose. The Setting Price + Center Stone Price = Total Price.</div>`

customize_setting_price_info_icon.addEventListener('mouseenter',()=>{
    document.getElementById('Customize-Metal-Size-Container').style.opacity = '0.1'
    customize_setting_price_info_text.style.display = 'block'
})
customize_setting_price_info_icon.addEventListener('mouseleave',()=>{
    document.getElementById('Customize-Metal-Size-Container').style.opacity = '1'
    customize_setting_price_info_text.style.display = 'none'
})

customize_product_price_ele.append(customize_setting_price_info_icon)
customize_product_price_ele.append(customize_setting_price_info_text)
